// 原始：10:折后 | 20:券后
const discountTypeValue = {
  0: "",
  10: '特惠价',
  20: '特惠价'
}
const discountTypeStyle = {
  0: "",
  10: 'is-discount',
  20: 'is-coupon'
}
export default {
  discountTypeValue,
  discountTypeStyle
}
